import { memo } from 'react';
import StatefulTabs from 'ui/widgets/StatefulTabs';
import IncrementExchangeRates from './IncrementExchangeRates';
import Files from './Files';
import Increments from './Increments';
import IncrementTax from './IncrementTax';
import SummaryFiles from './SummaryFiles';
import FileTaxCalculations from './FileTaxCalculations';
import SettlementsImportHistory from './SettlementsImportHistory';
import useMerchantPayouts from './useMerchantPayouts';
import Calculations from './Calculations';
import IncrementsPivot from './IncrementsPivot';

const MerchantPayouts = () => {
    const {
        isMerchantPayoutsLoading,
        getTabValue,
        onChangeTab
    } = useMerchantPayouts();

    return (
        <StatefulTabs
            TabProps={{
                disabled: isMerchantPayoutsLoading
            }}
            model={[
                {
                    label: 'Summary Files',
                    'data-test-id': 'merchantPayouts.tab.summaryFiles',
                    component: (
                        <SummaryFiles />
                    )
                },
                {
                    label: 'Files',
                    'data-test-id': 'merchantPayouts.tab.files',
                    component: (
                        <Files />
                    )
                },
                {
                    label: 'Calculations',
                    'data-test-id': 'merchantPayouts.tab.calculations',
                    component: (
                        <Calculations />
                    )
                },
                {
                    label: 'Increments',
                    'data-test-id': 'merchantPayouts.tab.increments',
                    component: (
                        <Increments />
                    )
                },
                {
                    label: 'Increments Pivot',
                    'data-test-id': 'merchantPayouts.tab.incrementsPivot',
                    component: (
                        <IncrementsPivot />
                    )
                },
                {
                    label: 'Files Tax Calc.',
                    'data-test-id': 'merchantPayouts.tab.filesTaxCalc',
                    component: (
                        <FileTaxCalculations />
                    )
                },
                {
                    label: 'Increments Taxes',
                    'data-test-id': 'merchantPayouts.tab.incrementsTaxes',
                    component: (
                        <IncrementTax />
                    )
                },
                {
                    label: 'Increment Exchange Rates',
                    'data-test-id': 'merchantPayouts.tab.incrementExchangeRates',
                    component: (
                        <IncrementExchangeRates />
                    )
                },
                {
                    label: 'Settlements Import History',
                    'data-test-id': 'merchantPayouts.tab.settlementsImportHistory',
                    component: (
                        <SettlementsImportHistory />
                    )
                }
            ]}
            value={getTabValue()}
            onChange={onChangeTab}
            TabListContainerProps={{
                borderBottom: 1,
                borderColor: 'divider'
            }}
            TabListProps={{
                'aria-label': "merchant payouts",
                variant: "scrollable",
                scrollButtons: "auto"
            }}
            TabPanelProps={{
                sx: {
                    padding: 1
                }
            }}
            ContainerProps={{
                pl: 1,
                sx: {
                    width: '100%'
                }
            }}
        />
    );
};

export default memo(MerchantPayouts);
